module.exports = __webpack_public_path__ + "media/images/views/home/home-features-bottom-fffcb036fd738f7c49c669fd423c5ded.png";